import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';

class LightboxController extends Controller {
  connect() {
    this.loadLightbox()
      .then((lightboxModule) => {
        lightboxModule.default.option({
          albumLabel: app.i18n.lightboxAlbumLabel,
        });

        this.transformElements();
      });
  }

  // eslint-disable-next-line class-methods-use-this
  loadLightbox() {
    return import(/* webpackChunkName: "lightbox" */ 'lightbox2');
  }

  transformElements() {
    const lightboxElements = toArray(this.element.querySelectorAll('[data-lightbox]'));

    lightboxElements.forEach((lightboxElement) => {
      lightboxElement.href = lightboxElement.getAttribute('data-href');
    });
  }
}

LightboxController.targets = [
  //
];

export default LightboxController;
